"use client";

import Link from "@casino/client/components/Link";
import Img from "@casino/legacyUi/Img";

type Props = {
  href: string;
  wrapperClassName: string;
  imgSrc: string;
  isMobile?: boolean;
};

const BannerImageLink: FC<Props> = ({
  href,
  wrapperClassName,
  imgSrc,
  isMobile,
}) => {
  const width = isMobile ? 477 : 788;
  const height = isMobile ? 312 : 516;

  return (
    <Link
      href={href}
      className={`${wrapperClassName} main-banner-image-logout`}
    >
      <Img width={width} height={height} src={imgSrc} alt="" preload />
    </Link>
  );
};

export default BannerImageLink;
